import { useEffect, useRef } from "react";
import { getUploadedExcelsList } from "../api/bulk-upload-api";

const useExcelListPolling = (
  currentPage,
  rowsPerPage,
  setTotalCount,
  setExcelList,
  polling
) => {
  const pollingIntervalRef = useRef(null);
  const getExcelList = async () => {
    try {
      const response = await getUploadedExcelsList(rowsPerPage, currentPage);
      const data = response?.data?.data;
      const total = response?.data?.total;

      setTotalCount(total);
      setExcelList(data);

      const shouldContinue = data?.some((item) => item.should_continue_polling);

      if (shouldContinue && polling) {
        if (!pollingIntervalRef.current) {
          pollingIntervalRef.current = setInterval(() => {
            getExcelList();
          }, 3000);
        }
      } else {
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
        }
      }
    } catch (error) {
      console.error("Error fetching excel list", error);
    }
  };

  useEffect(() => {
    getExcelList();

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [currentPage, rowsPerPage]);

  return { getExcelList };
};
export default useExcelListPolling;
